import React from 'react';

import type { DeliveryProductDetailsScreenProps } from '../../navigation/AppNavigation.props';
import { DeliveryProductDetails, DeliveryProductDetailsV2 } from './components';
import { usePdpV2QueryEnabled } from './hooks';

// ─────────────────────────────────────────────────────────────────────────────

export const DeliveryProductDetailsScreen = ({
  navigation,
  route,
}: DeliveryProductDetailsScreenProps) => {
  const {
    addressId,
    productSlug,
    ingredientIds,
    name: encodedName,
    reorderLineItemId,
  } = route.params ?? {};

  const isPdpV2QueryEnabled = usePdpV2QueryEnabled();

  const name = encodedName ? decodeURIComponent(encodedName) : null;
  const decodedIngredientIds = ingredientIds
    ? decodeURIComponent(ingredientIds)
    : null;

  const handleAddLineItemToCart = React.useCallback(() => {
    navigation.replace('Bag', { referrer: 'DeliveryMenu' });
  }, [navigation]);

  // ─────────────────────────────────────────────────────────────────────

  if (isPdpV2QueryEnabled) {
    return (
      <DeliveryProductDetailsV2
        addressId={addressId}
        productSlug={productSlug}
        reorderLineItemId={reorderLineItemId}
        onAddLineItemToCart={handleAddLineItemToCart}
        isEditProductMode={false}
      />
    );
  }

  // ─────────────────────────────────────────────────────────────────────

  return (
    <DeliveryProductDetails
      addressId={addressId}
      productSlug={productSlug}
      ingredientIds={decodedIngredientIds?.split(',')}
      onAddLineItemToCart={handleAddLineItemToCart}
      reorderLineItemId={reorderLineItemId}
      // @ts-expect-error TS(2322): Type 'string | null' is not assignable to type 'st... Remove this comment to see the full error message
      name={name}
      isDelivery
    />
  );
};
